import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    height: 56,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(0, 4),
    marginBottom: theme.spacing(2)
  },
  chipRoot: {
    height: 36,
    padding: theme.spacing(2, 5),
    backgroundColor: theme.colorPalette.white_30,
    borderRadius: 0,
    marginLeft: theme.spacing(4),
    color: theme.colors.info__label_primary
  },
  left: {
    fontSize: 14,
    color: theme.colors.info__label_primary
  },
  rightContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  assignation: {
    fontSize: 12,
    color: theme.colors.info__label_primary
  },
  modal: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6)
  },
  assignDriversTitle: {
    padding: theme.spacing(14, 6, 7)
  },
  assignDriversSubtitle: {
    fontSize: 16,
    marginTop: theme.spacing(6)
  },
  assignDriversFooter: {
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  footerButton: {
    padding: theme.spacing(0, 11)
  }
}));
